import { render } from "./listXy.vue?vue&type=template&id=28682f02"
import script from "./listXy.vue?vue&type=script&lang=js"
export * from "./listXy.vue?vue&type=script&lang=js"

import "./listXy.vue?vue&type=style&index=0&id=28682f02&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__